import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({ name: 'formatDrt' })
export class DateDurationPipe implements PipeTransform {
  transform(value: Date) {
    if (!(value instanceof Date)) value = new Date(value);

    let seconds: number = Math.floor(
      (new Date().getTime() - value.getTime()) / 1000
    );
    let interval: number = Math.floor(seconds / 31536000);
    interval = Math.floor(seconds / 31104000);
    if (interval > 1) {
      return Math.abs(Math.floor(interval)) + ' năm trước';
    }

    interval = Math.floor(seconds / 2592000);
    if (interval > 1) {
      return Math.abs(Math.floor(interval)) + ' tháng trước';
    }
    interval = Math.floor(seconds / 86400);
    if (interval > 1) {
      return Math.abs(Math.floor(interval)) + ' ngày trước';
    }
    interval = Math.floor(seconds / 3600);
    if (interval > 1) {
      return Math.abs(Math.floor(interval)) + ' giờ trước';
    }
    interval = Math.floor(seconds / 60);
    if (interval > 1) {
      return Math.abs(Math.floor(interval)) + ' phút trước';
    }
    return Math.abs(Math.floor(seconds + 1)) + ' giây trước';
  }
}
